import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Video } from 'src/app/models/video.model';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.scss']
})
export class VideosComponent  implements OnInit{

  constructor(private userService: UsersService) { }
  ngOnInit(): void {
    this.userService.currentUser.subscribe(u => this.userId = u.userId)
     this.rand=Math.floor(Math.random() * 7)
  }

  @Input()
  videos: Video[] = []
userId:number
rand:number
  @Output()
  removedFromFavorites = new EventEmitter<string>()

  removeVideo(video_Id: string) {
    this.removedFromFavorites.emit(video_Id)
  }


  // @HostListener('window:resize')
  // calculateVideoCardHeight(): number {
  //   const videoCardWidth = this.elementRef.nativeElement.width;
  //   const height = (videoCardWidth * (9 / 16)) + 55;
  //   return height;
  // }
}
